import { apiFetch } from "../useApi";

export default async function getDevices() {
  const response = await apiFetch(`/devices`);
  return response.json();
}
